import styled from "styled-components";

export const MeetingContainer = styled.div`
    padding-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
`;

export const MeetingSelectContainer = styled.div`
    width: 400px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 60px;
    align-items: flex-start;
`;

export const NewButtonContainer = styled.div`
    height: 60%;
    margin-top: 7px;
    display: flex;
    margin-left: 20px;
    justify-content: flex-start;
`;

export const MeetingTableContainer = styled.div`
    width: 100%;
`;

export const MeetingConfContainer = styled.div`
    min-width: 80%;
`;

export const Center = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 20px;
`;